"use client";

import { useEffect } from "react";
import {
  initializePWA,
  handlePromptDismissal,
  isInstalledNoticeAllowed,
  saveInstalledNoticeState,
} from "@shared/src/utils/pwa-manager";
import { usePWA } from "@shared/src/hooks/usePWA";
import { ixToast } from "@shared/src/utils/ixToast";
import { Button } from "@shared/src/components/ui/button";
import { Download } from "lucide-react";

export function PWAProvider({ children }: { children: React.ReactNode }) {
  const pwa = usePWA();

  useEffect(() => {
    console.log("==== PWA Provider Initializing ====");
    let cleanupFn: (() => void) | undefined;

    initializePWA().then(cleanup => {
      cleanupFn = cleanup;
    });

    return () => {
      if (cleanupFn) cleanupFn();
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      // Skip prompts in embedded browsers
      if (typeof window !== "undefined" && window.self !== window.top) {
        console.log("Skipping PWA prompts in embedded browser");
        return;
      }

      console.log("PWA State after delay:", {
        isInstalled: pwa.isInstalled,
        isInstallable: pwa.isInstallable,
      });

      if (pwa.isInstalled) return;

      if (pwa.isInstallable) {
        console.log("Showing install prompt toast");
        // ixToast.custom({
        //   title: "Install iExchange",
        //   description: "Install our app for a better experience",
        //   position: "top-center",
        //   permanent: true,
        //   onOpenChange: open => {
        //     console.log("Toast onOpenChange:", open);
        //     if (!open) {
        //       console.log("User dismissed install prompt toast");
        //       setTimeout(() => {
        //         handlePromptDismissal();
        //       }, 100);
        //     }
        //   },
        //   action: (
        //     <Button
        //       variant="ghost"
        //       onClick={async () => {
        //         console.log("Install button clicked");
        //         const result = await pwa.install();

        //         if (result === "unavailable") {
        //           ixToast.info("Installation not available. Please use your browser's install option.");
        //         } else if (result === "accepted") {
        //           ixToast.success("Installing app...");
        //         } else {
        //           ixToast.info("Installation cancelled");
        //         }

        //         ixToast.dismiss();
        //       }}
        //       className="bg-button-tertiary-bg text-text-primaryinverse rounded-full"
        //     >
        //       <Download size={16} />
        //       Install
        //     </Button>
        //   ),
        // });
      }
      // else if (isInstalledNoticeAllowed()) {
      //   console.log("Showing installed notice");
      //   ixToast.info("iExchange is installed! Check your device or browser to access the app.", {
      //     title: "iExchange Installed",
      //     position: "bottom-right",
      //   });
      //   saveInstalledNoticeState();
      // }
    }, 2000);

    return () => clearTimeout(timer);
    //TODO; @EpaphrasSam Change this to [pwa, pwa.isInstallable, pwa.isInstalled] after fixing the issue
  }, [pwa.isInstallable, pwa.isInstalled]);

  return <>{children}</>;
}
